import { Box, Skeleton } from "@mui/material";

const TicketSkeletonLoading = () => (
    <div className="ticket-flip-inner" >
      <div className="ticket-flip-front">
        <Box
          sx={{
            borderRadius: "24px",
            boxShadow: "0 4px 24px rgba(0,0,0,0.12)",
            overflow: "hidden",
            background: "#fff",
            minHeight: 500,
            width: "80%",
            justifyContent: "center",
            pb: 1,
          }}
        >
          {/* Header Skeleton */}
          <Box sx={{ bgcolor: "#3B5998", p: 2, borderTopLeftRadius: "24px", borderTopRightRadius: "24px" }}>
            <Skeleton width="40%" height={24} />
            <Skeleton width="30%" height={16} sx={{ mt: 1 }} />
          </Box>
          
          {/* Banner Skeleton */}
          <Skeleton variant="rectangular" width="100%" height={140} />
          
          {/* Avatar Skeleton */}
          <Box sx={{ display: "flex", justifyContent: "left", mt: -6, ml: 2 }}>
            <Skeleton variant="circular" width={90} height={90} />
          </Box>
          
          {/* Info Skeleton */}
          <Box sx={{ px: 2, mt: 2 }}>
            <Skeleton width="70%" height={28} />
            <Skeleton width="90%" height={20} sx={{ mt: 1 }} />
            <Skeleton width="80%" height={20} sx={{ mt: 1 }} />
          </Box>
          
          <Box sx={{ px: 2, mt: 3 }}>
            <Skeleton width="60%" height={28} />
            <Skeleton width="40%" height={24} sx={{ mt: 1 }} />
          </Box>
          
          <Box sx={{ px: 2, mt: 2 }}>
            <Skeleton width="100%" height={20} />
            <Skeleton width="100%" height={20} sx={{ mt: 1 }} />
            <Skeleton width="100%" height={20} sx={{ mt: 1 }} />
            <Skeleton width="100%" height={20} sx={{ mt: 1 }} />
          </Box>
        </Box>
      </div>
    </div>
  );

  export default TicketSkeletonLoading